export default "__VITE_ASSET__Qb8jY3Cl__"